<template>
  <div>
    <div v-if="isHoliday" class="position-fixed">
      <div><b>Feriado:</b> {{ event.title }}</div>
    </div>
    <div v-else-if="inVacation">
      <div><b>{{ technicianInitials }}</b> - {{ event.title }}</div>
    </div>
    <div v-else-if="isMissed">
      <div><b>{{ technicianInitials }}</b> - Falta</div>
    </div>

    <div v-else>
      <div class="p-d-flex p-jc-between">
        <div v-tooltip="mainTooltipContent">
          <b>{{ technicianInitials }}</b>
          <template v-if="taskInfo.marcada">
            <b>- Confirmado</b>
          </template>
        </div>
        <div class="p-d-flex p-m-1">
          <AppPopover :value="toggle" trigger="hover">
            <i class="pi pi-info-circle p-mr-1"></i>
            <div slot="content">
              <div v-if="taskInfo.isBooking">
              <div>{{ timeText }}</div>
                <b>{{ taskInfo.type === 1 ? 'Reservado' : 'Indisponível' }}</b><br/>
                <b>Técnico: </b>{{ taskInfo.technician }}
              </div>
              <div v-else>
                <small>
                  <b>Pat: </b> {{ taskInfo.pat_number }} - {{ taskInfo.pat_status }}<br/>
                  <b>Tipo: </b> {{ taskInfo.pat_type_name }}<br/>
                  <b>Marca:</b> {{ taskInfo.pat_brand }}<br />
                  <b>Técnico: </b> {{ taskInfo.technician }}<br/>
                  <b>Dia/Hora: </b> {{ taskInfo.start }} {{ taskInfo.start_hour }}<br/>
                  <b>Cliente: </b> {{ taskInfo.contact_name }}<br/>
                  <div v-if="taskInfo.entity_name">
                    <b>Entidade: </b> {{ taskInfo.entity_name }}<br/>
                  </div>
                  <b>Morada: </b>
                  {{ taskInfo.localization ? taskInfo.localization.address : '' }}
                  {{ taskInfo.localization ? taskInfo.localization.zip_code : '' }}
                  {{ taskInfo.localization ? taskInfo.localization.local : '' }}<br/>
                  <b>Telefone: </b>
                  {{ taskInfo.contact_phone }}<br/>
                  <div v-if="!taskInfo.entity_name">
                    <b>Telemóvel: </b> {{ taskInfo.contact_phone }}<br/>
                  </div>
                  <div v-if="taskInfo.pat_solution">
                    <b>Solução: </b> {{ taskInfo.pat_solution }}<br/>
                  </div>
                  <div v-if="taskInfo.note">
                    <b>Notas: </b> {{ taskInfo.note }}<br/>
                  </div>
                </small>
                <div class="p-mt-2">
                  <Button
                    label="Ver Pat"
                    icon="pi pi-eye"
                    class="p-button-sm p-button-success"
                    @click="goToPat(taskInfo.pat_number)"
                  />
                </div>
              </div>
            </div>
          </AppPopover>
          <a href="#" @click.prevent="toggleMenu" class="anchor-menu" v-tooltip="'Ações'">
            <i class="pi pi-ellipsis-h"></i>
          </a>
          <Menu ref="menu" appendTo="body" :model="items" :popup="true" />
        </div>
      </div>
      <div>
        <div>{{ timeText }}</div>
        <div v-if="taskInfo.isBooking">
          <b v-if="taskInfo.type == 1">Reservado</b>
          <b v-if="taskInfo.type == 2">Indisponível</b>
        </div>
        <div v-else class="text-ellipsis" v-tooltip="taskInfo.entity_name">
          <b> {{ taskInfo.entity_name }} </b>
        </div>
        <div v-if="taskInfo.pat_type_name" class="text-ellipsis">
          <b>PAT:</b> {{ taskInfo.pat_number }}
        </div>
      </div>
      <div v-if="taskInfo.pat_number">
        {{ taskInfo.pat_brand }} | {{ taskInfo.pat_model }}
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "primevue/menu";
import Button from "primevue/button";
import AppPopover from '../elements/AppPopover.vue';

export default {
  name: "EventContent",
  components: { AppPopover, Menu, Button },
  props: {
    eventArg: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      toggle: false,
      items: [
          {
              label: 'Ações',
              items: [
                  {
                      label: 'Editar tarefa',
                      icon: 'pi pi-pencil',
                      visible: () => this.canPerformActions,
                      command: this.onUpdate
                  },
                  {
                      label: 'Ver tarefa',
                      icon: 'pi pi-eye',
                      visible: () => !this.canPerformActions,
                      command: this.onUpdate
                  },
                  {
                      label: 'Clonar',
                      icon: 'pi pi-clone',
                      visible: () => this.canPerformActions,
                      command: this.onClone
                  },
                  {
                      label: 'Eliminar Tarefa',
                      icon: 'pi pi-trash',
                      visible: () => this.canDelete,
                      command: this.onDelete
                  },
              ]
          }
      ]
    }
  },
  computed: {
    event() {
      return this.eventArg.event;
    },
    timeText() {
      return this.eventArg.timeText;
    },
    taskInfo() {
      return this.event.extendedProps.taskInfo || {};
    },
    loggedUser() {
      return this.$store.state.auth.user;
    },
    isHoliday() {
      return this.event.extendedProps.isHoliday;
    },
    inVacation() {
      return this.event.extendedProps.inVacation;
    },
    isMissed() {
      return this.event.extendedProps.missed;
    },
    technicianInitials() {
      return this.event.extendedProps.technicianInitials || this.taskInfo.technician_initials;
    },
    canDelete() {
      return this.event.extendedProps.canDelete || false;
    },
    canEditTask() {
        return this.event.extendedProps.canEditTask || false;
    },
    canPerformActions() {
      return this.eventArg.isDraggable && (this.taskInfo.created_by === this.loggedUser.username || this.canEditTask);
    },
    addressString() {
        const { address, zip_code, local } = this.taskInfo.localization || {};
        let parts = [];
        if (address) parts.push(address);
        if (zip_code) parts.push(zip_code);
        if (local) parts.push(local);
        return parts.join(' ');
    },
    mainTooltipContent() {
      if (this.taskInfo.isBooking) {
        const type = this.taskInfo.type === 1 ? 'Reservado' : 'Indisponível';
        return `<div>${this.timeText}<br/><b>${type}</b><br/><b>Técnico: </b>${this.taskInfo.technician}</div>`;
      }
      return `<div>
        ${this.timeText}<br/>
        <b>Técnico: </b>${this.taskInfo.technician || ''}<br/>
        <b>PAT: </b>${this.taskInfo.pat_number || ''}<br/>
        <b>Tipo: </b>${this.taskInfo.pat_type_name || ''}<br/>
        <b>MARCA: </b>${this.taskInfo.pat_brand || ''}<br/>
        <b>Título: </b>${this.taskInfo.pat_title || ''}<br/>
        <b>Cliente: </b>${this.taskInfo.contact_name || ''}<br/>
        <b>Morada: </b>${this.addressString}
      </div>`;
    },
    infoTooltipContent() {
      if (this.taskInfo.isBooking) {
        const type = this.taskInfo.type === 1 ? 'Reservado' : 'Indisponível';
        return `<div>${this.timeText}<br/><b>${type}</b><br/><b>Técnico: </b>${this.taskInfo.technician}</div>`;
      }
      return `<div>
        ${this.timeText}<br/>
        <b>Tipo de Serviço: </b>${this.taskInfo.pat_type_name || ''}<br/>
        <b>Técnico: </b>${this.taskInfo.technician || ''}<br/>
        <b>PAT: </b>${this.taskInfo.pat_number || ''}<br/>
        <b>MARCA: </b>${this.taskInfo.pat_brand || ''}<br/>
        <b>Título: </b>${this.taskInfo.pat_title || ''}<br/>
        <b>Cliente: </b>${this.taskInfo.contact_name || ''}<br/>
        <b>Morada: </b>${this.addressString}
      </div>`;
    },
  },
  methods: {
    onDelete() {
      this.$emit('delete', this.event.id);
    },
    onClone() {
      this.$emit('clone', this.event.id);
    },
    onUpdate() {
      this.$emit('update', this.event.id);
    },
    goToPat(patId) {
      this.$router.push(`/pats/${patId}`);
    },
    toggleMenu(event) {
      this.$refs.menu.toggle(event);
    }
  },
};
</script>

<style scoped>
.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.anchor-menu {
  cursor: pointer;
  color: #000;
  padding: 2px 3px;
}
</style>